import ReactSelect from "react-select"
import { FocusEvent } from "react"
import {
  searchableSelectStyles,
  SearchableSelectFieldProps_Option,
} from "components/common/formFields/SearchableSelectField/SearchableSelectField"

export interface SearchableMultiSelectFieldProps {
  options: SearchableSelectFieldProps_Option[] | undefined
  isLoading?: boolean
  values: (string | number)[]
  isInvalid?: boolean
  onChange: (newValues: (string | number)[]) => void
  onBlur?: (event: FocusEvent) => void
}

export const SearchableMultiSelectField = (props: SearchableMultiSelectFieldProps) => {
  const selectedOptions = props.options?.filter(option => props.values.includes(option.value)) ?? []

  return (
    <ReactSelect
      isMulti
      // Keep the menu open so several values can be picked in a row
      closeMenuOnSelect={false}
      placeholder="Velg"
      noOptionsMessage={() => "Ingen flere valg"}
      menuPortalTarget={document.body}
      options={props.options}
      isLoading={props.isLoading}
      value={selectedOptions}
      onChange={(newValue) => props.onChange(newValue.map(option => option.value))}
      onBlur={props.onBlur}
      menuPlacement={"auto"}
      aria-invalid={props.isInvalid}
      styles={searchableSelectStyles<SearchableSelectFieldProps_Option, true>(props.isInvalid)}
    />
  )
}
